import AuthlessA5PrintPage from "@/components/common-receipt/AuthlessA5PrintPage";
import { selectFirstPrintRowOrEmpty } from "@/components/common-receipt/select-print-row";
import {
  projectTakhmeenReceiptA5Props,
  type ProjectTakhmeenReceiptPrintRecord,
} from "./project-takhmeen-receipt-print-content";

const ProjectTakhmeenReceiptPrint = () => (
  <AuthlessA5PrintPage<ProjectTakhmeenReceiptPrintRecord>
    location="projectTakhmeenReceipts"
    buildId={(routeId) => `print/${routeId}`}
    selectRow={selectFirstPrintRowOrEmpty}
    toProps={projectTakhmeenReceiptA5Props}
  />
);

export default ProjectTakhmeenReceiptPrint;
